var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (t, e, r) => e in t ? i(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, m = (t, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && a(t, r, e[r]);
  if (o)
    for (var r of o(e))
      n.call(e, r) && a(t, r, e[r]);
  return t;
}, f = (t, e) => p(t, c(e));
import d, { forwardRef as l } from "react";
import w from "../lib/IconBase.mjs";
import C from "../defs/CaretLeft.mjs";
const L = l((t, e) => /* @__PURE__ */ d.createElement(w, f(m({ ref: e }, t), { weights: C })));
L.displayName = "CaretLeft";
export {
  L as CaretLeft
};
